import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import {default as MuiMenuItem} from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import makeStyles from '@mui/styles/makeStyles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useMenu} from 'components/Menu/hooks';
import React from 'react';

type SubMenuItemProps = {
   name: string;
   children: React.ReactNode;
   disabled?: boolean;
};

const useStyles = makeStyles((theme) => ({
   menuItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
   },
   submenuWrapper: {
      zIndex: theme.zIndex.modal,
   },
   paper: {
      maxHeight: '85vh',
      overflowY: 'auto',
      overflowX: 'visible',
      marginTop: theme.spacing(1),
      '& .MuiList-padding': {
         // padding: 0,
      },
   },
}));

const SubMenuItem = ({name, children, disabled}: SubMenuItemProps) => {
   const classes = useStyles();
   const {open, anchorRef, handleToggle, handleClose, handleListKeyDown} = useMenu<HTMLLIElement>();

   return (
      <>
         <MuiMenuItem
            disabled={disabled}
            className={classes.menuItem}
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
         >
            <span>{name}</span>
            <ChevronRightIcon />
         </MuiMenuItem>
         <Popper
            open={open}
            anchorEl={anchorRef.current}
            placement="right-start"
            role={undefined}
            transition
            className={classes.submenuWrapper}
            // disablePortal
         >
            {({TransitionProps}) => (
               <Grow
                  {...TransitionProps}
                  style={{
                     transformOrigin: 'left',
                  }}
               >
                  <Paper elevation={5} className={classes.paper}>
                     <ClickAwayListener onClickAway={handleClose}>
                        <MenuList
                           autoFocusItem={open}
                           id="menu-list-grow"
                           onKeyDown={handleListKeyDown}
                        >
                           {children}
                        </MenuList>
                     </ClickAwayListener>
                  </Paper>
               </Grow>
            )}
         </Popper>
      </>
   );
};

export default SubMenuItem;
